import FileReference from '@kaizenplatform/belfast-entity/dist/entity/FileReference';
import { useCallback, useContext, useEffect, useState } from 'react';

import { SingleAssignmentFragment } from '../../../graphql/generated/graphql_offer';
import { CreationSet } from '../../../service/persistent/CreationSetWebApi';
import { context as DependencyContext } from '../../context/dependency';

const useGetCreationSetQuery = (offerId: string, assignmentId: string | null) => {
  const dependency = useContext(DependencyContext);

  const [res, setRes] = useState<CreationSet>();
  const [assignment, setAssignment] = useState<SingleAssignmentFragment>();
  const [briefFiles, setBriefFiles] = useState<Map<string, FileReference[]>>(new Map());
  const [assetFiles, setAssetFiles] = useState<FileReference[]>([]);
  const [loading, setLoading] = useState(0);
  const fetchData = useCallback(async () => {
    setLoading((loading) => ++loading);
    const res = await dependency.creationSetWebApi.get({ offerId, assignmentId });
    Promise.all([
      dependency.offer.assignmentWebApi.get(res.currentAssignmentId),
      dependency.showProjectUsecase.getFiles(res.project),
    ]).then((values) => {
      setRes(res);
      setAssignment(values[0]);
      const { briefFiles, assetFiles } = values[1];
      setBriefFiles(briefFiles);
      setAssetFiles(assetFiles);
      setLoading((loading) => --loading);
    });
  }, [
    dependency.creationSetWebApi,
    dependency.offer.assignmentWebApi,
    dependency.showProjectUsecase,
    offerId,
    assignmentId,
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { creationSet: res, assignment, briefFiles, assetFiles, loading: loading > 0, reload: fetchData };
};

export default useGetCreationSetQuery;
